/* eslint-disable array-bracket-newline,array-element-newline */
const specialCharacters = [
  [ /!/g, '{ex}', /{ex}/g, '!', ],
  [ /\*/g, '{ast}', /{ast}/g, '*', ],
  [ /'/g, '{ap}', /{ap}/g, '\'', ],
  [ /\(/g, '{prl}', /{prl}/g, '(', ],
  [ /\)/g, '{prr}', /{prr}/g, ')', ],
  [ /;/g, '{sc}', /{sc}/g, ';', ],
  [ /:/g, '{c}', /{c}/g, ':', ],
  [ /@/g, '{at}', /{at}/g, '@', ],
  [ /&/g, '{amp}', /{amp}/g, '&', ],
  [ /=/g, '{eq}', /{eq}/g, '=', ],
  [ /\+/g, '{pl}', /{pl}/g, '+', ],
  [ /\$/g, '{dol}', /{dol}/g, '$', ],
  [ /,/g, '{com}', /{com}/g, ',', ],
  [ /\//g, '{sl}', /{sl}/g, '/', ],
  [ /\?/g, '{q}', /{q}/g, '?', ],
  [ /#/g, '{h}', /{h}/g, '#', ],
  [ /\[/g, '{brl}', /{brl}/g, '[', ],
  [ /]/g, '{brr}', /{brr}/g, ']', ],
  [ /%/g, '{ps}', /{ps}/g, '%', ],
]
/* eslint-enable array-bracket-newline,array-element-newline */

export const urlSpecialCharEncoder = (str) => {
  let result = str
  specialCharacters
    .filter((replaceTemplate) => replaceTemplate[0].test(result))
    .forEach((replaceTemplate) => result = result.replace(replaceTemplate[0], replaceTemplate[1]))
  return result
}

export const urlSpecialCharDecoder = (str) => {
  let result = str
  specialCharacters
    .filter((replaceTemplate) => replaceTemplate[2].test(result))
    .forEach((replaceTemplate) => result = result.replace(replaceTemplate[2], replaceTemplate[3]))
  return result
}



// WEBPACK FOOTER //
// ./src/utils/urlSpecialCharHandlers.js